import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SxContextService } from "app/infrastructure/services/sxContext.service";
import { CategoryService } from "app/infrastructure/services/category.service";
import { NgxSmartModalService } from "ngx-smart-modal";
import { Categories } from 'app/infrastructure/model/interfaces/categories.interface';

@Component({
  selector: 'sx-category-component',
  templateUrl: './categoryModal.component.html',
  styleUrls: ['./categoryModal.component.css'],
})

export class CategoryModalComponent implements OnInit, OnDestroy {
  @Output() filteredCategories = new EventEmitter<Categories>();


  context: {
    organizationCode: string
    subscriptionCode: string
    channelCode: string
    productCode: string
  }
  categories: Categories = { organizations: [], subscriptions: [], regions: [], countries: [] };
  allOrganizations: number = 0;
  allSubscriptions: number = 0;
  allRegions: number = 0;
  allCountries: number = 0;
  sourceCategories: Categories = null; //is and axiliar cache category to cancel or apply changes
  initialCategories: Categories = null;
  isCheckedSubscription: boolean = true;
  isCheckedOrganization: boolean = true;
  isCheckedRegion: boolean = true;
  isCheckedCountry: boolean = true;

  constructor(public router: Router, public aRoute: ActivatedRoute,
    private sxContext: SxContextService,
    public ngxSmartModalService: NgxSmartModalService,
    private categoryservice: CategoryService) {
  }

  ngOnInit() {
    this.sxContext.getContext(this.aRoute).subscribe(context => {
      this.context = context;
    })
  }

  ngOnDestroy() {

  }
  mapArray(entity: Categories): Categories {
    return {
      countries: entity.countries.map(e => ({ ...e })), organizations: entity.organizations.map(e => ({ ...e })),
      regions: entity.regions.map(e => ({ ...e })), subscriptions: entity.subscriptions.map(e => ({ ...e }))
    };
  }
  setCategoryProperties(entity: Categories) {
    this.categories = entity;
    this.categoryservice.sourceCategories = this.mapArray(entity);
    this.sourceCategories = this.mapArray(entity);
    this.initialCategories = this.mapArray(entity);
    this.allCountries = entity.countries.filter(x => x.isSelected).length;
    this.allOrganizations = entity.organizations.filter(x => x.isSelected).length;
    this.allRegions = entity.regions.filter(x => x.isSelected).length;
    this.allSubscriptions = entity.subscriptions.filter(x => x.isSelected).length;
  }

  OpenModal() {
    if (this.sourceCategories == null) {
      this.categoryservice.getCategoriesList(this.context).subscribe(entity => {
        this.setCategoryProperties(entity);
        this.ngxSmartModalService.setModalData({}, 'configModalCategory');
        this.ngxSmartModalService.getModal('configModalCategory').open();
      });
    } else {
      this.setCategoryProperties(this.sourceCategories);
      this.ngxSmartModalService.setModalData({}, 'configModalCategory');
      this.ngxSmartModalService.getModal('configModalCategory').open();
    }
  }
  close() {
    this.categories = this.mapArray(this.sourceCategories);
    this.isAllOrganizationsSelected();
    this.isAllSubscriptionsSelected();
    this.isAllRegionsSelected();
    this.isAllCountriesSelected();
    this.ngxSmartModalService.closeLatestModal();
  }
  apply() {
    this.categoryservice.sourceCategories = this.mapArray(this.categories);
    this.sourceCategories = this.mapArray(this.categories);
    this.allOrganizations = this.categories.organizations.filter(x => x.isSelected === true).length;
    this.allSubscriptions = this.categories.subscriptions.filter(x => x.isSelected === true).length;
    this.allCountries = this.categories.countries.filter(x => x.isSelected === true).length;
    this.allRegions = this.categories.regions.filter(x => x.isSelected === true).length;

    this.ngxSmartModalService.closeLatestModal();
    this.filteredCategories.emit(this.categories);
  }

  isAllOrganizationsSelected() {
    this.isCheckedOrganization = this.categories.organizations.every(function (item: any) {
      return item.isSelected;
    })
  }
  isAllSubscriptionsSelected() {
    this.isCheckedSubscription = this.categories.subscriptions.every(function (item: any) {
      return item.isSelected;
    })
  }
  isAllCountriesSelected() {
    this.isCheckedCountry = this.categories.countries.every(function (item: any) {
      return item.isSelected;
    })
  }
  isAllRegionsSelected() {
    this.isCheckedRegion = this.categories.regions.every(function (item: any) {
      return item.isSelected;
    })
  }
  checkSubcription(value: boolean) {
    this.categories.subscriptions.forEach(category => {
      category.isSelected = value;
    });
  }
  checkOrganization(value: boolean) {
    this.categories.organizations.forEach(category => {
      category.isSelected = value;
    });
  }
  checkCountry(value: boolean) {
    this.categories.countries.forEach(category => {
      category.isSelected = value;
    });
  }
  checkRegion(value: boolean) {
    this.categories.regions.forEach(category => {
      category.isSelected = value;
    });
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/category/categoryModal.component.ts